import type * as React from 'react';

import { images } from '@gitbook/doc-core';
import type { BlockProps } from '@gitbook/slate-react';

import { Image } from '../../Image';

/**
 * Basic renderer for an image block.
 */
export function BasicBlockImage(props: BlockProps): React.ReactElement {
    const { node } = props;

    const ref = node.data.get('ref');
    const altText = images.getImageAltText(node);
    const { url } = ref;

    return (
        <Image source={{ uri: url }} style={[{ maxWidth: '100%' }]} accessibilityLabel={altText} />
    );
}
